import * as React from 'react';
import { CoauthorInformation } from '../CoauthorInformation';
import { getCoauthorSectionStyle, CoauthorGalleryPalette } from '../Styles';
import { sortCoauthors } from '../utilities';
import { getCoauthorSectionItem } from './getCoauthorSectionItem';

/**
 * Function that can be used to render a list of coauthors.
 * @param coauthors list of coauthors to render
 */
export const onRenderCoauthorSection = (
  coauthors: CoauthorInformation[],
  palette: CoauthorGalleryPalette,
  fallBackUserImage?: string,
  onCoauthorMenuItemExecute?: (ev: React.MouseEvent<HTMLDivElement>, coauthor: CoauthorInformation) => void
): (() => JSX.Element) => {
  return () => (
    <div role="presentation" key={'coauthor-menu-coauthors'}>
      <ul style={getCoauthorSectionStyle(palette).container} role="group">
        {sortCoauthors(coauthors).map((coauthor, index, coauthors) =>
          getCoauthorSectionItem(coauthor, index, coauthors, palette, fallBackUserImage, onCoauthorMenuItemExecute)
        )}
      </ul>
    </div>
  );
};
